// Collapses any run of slashes (including a missing or doubled trailing
// slash) down to exactly one trailing slash, so a single canonical URL is
// always used regardless of how the path was requested or how the Contentful
// slug was authored.
export const canonicalizeTrailingSlash = (pathname) => {
  const collapsed = pathname.replace(/\/{2,}/g, '/');
  const withoutTrailingSlash = collapsed.replace(/\/+$/, '');
  return `${withoutTrailingSlash}/`;
};
